import React, { FC } from 'react';
import * as linkify from 'linkifyjs';
// @ts-ignore
import mention from 'linkifyjs/plugins/mention';
import Linkify from 'linkifyjs/react';
import {
  getAllUsers,
  getProjectMembers,
  getProjectUsers
} from '../../models/Project';

import { Props } from './types';
import {
  getUserMentionTitle,
  getTaskMentionTitle,
  getUser,
  getTask,
  isTaskMention
} from './utils';
import { getBugherd } from 'appJS/models/Application';
import { UserMention } from './UserMention';
import { TaskMention } from './TaskMention';

mention(linkify);

export const mentionRegex: RegExp = /@\[([^\[]+)\]\(([\d\)]+)\)/g;

const HighlightedMentions: FC<Props> = ({
  description = '',
  className,
  isComment,
  isPrivate,
  includeGuests,
  allUsers,
  projectUsers,
  projectMembers,
  mentionableTasks = [],
  setActiveTask
}) => {
  allUsers = allUsers || getAllUsers();
  projectUsers = includeGuests
    ? projectUsers || getProjectUsers()
    : projectMembers || getProjectMembers();

  const bugherd = getBugherd();
  if (bugherd) {
    const application = bugherd.application;
    if (application) {
      if (!mentionableTasks.length) {
        mentionableTasks = application.tasksCollection.mentionableTasks();
      }
      if (!setActiveTask) {
        setActiveTask = (taskId: number) => {
          const task = application.tasksCollection.get(taskId);
          bugherd.applicationView.openTask(task);
          bugherd.applicationRouter.navigate(
            `tasks/${task.get('local_task_id').toString()}`
          );
        };
      }
    }
  }

  const getTitle = (match: string): string => {
    const id = match.slice(1);
    if (isTaskMention(description, id)) {
      return getTaskMentionTitle({ id, task: getTask(id, mentionableTasks) });
    } else {
      const user = getUser(id, allUsers);
      const projectUser = getUser(id, projectUsers);
      return getUserMentionTitle({ id, projectUser, user });
    }
  };

  return (
    <Linkify
      options={{
        tagName: {
          mention: 'span'
        },
        attributes: match => ({
          rel: 'noreferrer',
          title: getTitle(match)
        }),
        events: { click: (event: MouseEvent) => event.stopPropagation() },
        target: '_blank',
        format: {
          // @ts-expect-error
          mention: (mention: string) => {
            const id = mention.slice(1);
            if (isTaskMention(description, id)) {
              const task = getTask(id, mentionableTasks);
              return (
                <TaskMention
                  task={task}
                  setActiveTask={setActiveTask}
                  description={description}
                  id={id}
                />
              );
            }
            const projectUser = getUser(id, projectUsers);
            const user = getUser(id, allUsers);
            return (
              <UserMention
                id={id}
                description={description}
                user={user}
                projectUser={projectUser}
                isComment={isComment}
                isPrivate={isPrivate}
              />
            );
          }
        }
      }}
      className={className}
    >
      {(description || '').replace(mentionRegex, '@$2')}
    </Linkify>
  );
};

export default HighlightedMentions;
